import { useState } from "react";
import HOT_ICON from "@/assets/images/hot.svg";

function ChevronGlyph() {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <path
        d="M4 6l4 4 4-4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function LeagueLogo({ src, label }) {
  const [broken, setBroken] = useState(false);
  const show = Boolean(src) && !broken;
  const letter = String(label || "?").trim().charAt(0).toUpperCase() || "?";
  return (
    <span className={`kbv-ltd-sb-logo ${show ? "" : "is-fallback"}`}>
      {show ? <img src={src} alt="" onError={() => setBroken(true)} /> : <span>{letter}</span>}
    </span>
  );
}

export default function LeagueGroup({ league, matches, render }) {
  const [expanded, setExpanded] = useState(true);
  const name = league?.nameVN ?? league?.name ?? "";
  const list = matches || [];

  return (
    <div className="kbv-ltd-sb-card kbv-kq-sb-group">
      <button
        type="button"
        className="kbv-kq-sb-head"
        aria-expanded={expanded}
        onClick={() => setExpanded((prev) => !prev)}
      >
        <LeagueLogo src={league?.logo} label={name} />
        <span className="kbv-kq-sb-head-title">
          <span className="kbv-kq-sb-head-name" title={name}>
            {name}
          </span>
          {league?.isHot ? (
            <img src={HOT_ICON} alt="HOT" className="kbv-kq-sb-hot" />
          ) : null}
        </span>
        <span className={`kbv-ltd-sb-chevron ${expanded ? "is-open" : ""}`}>
          <ChevronGlyph />
        </span>
      </button>
      {expanded
        ? list.map((match, idx) => render(match, idx === list.length - 1))
        : null}
    </div>
  );
}
